import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSmartBack } from '@/composables/use-smart-back'
import {
  NavBar as VanNavBar,
  Icon as VanIcon,
  List as VanList,
  PullRefresh as VanPullRefresh,
  Sticky as VanSticky,
  Row as VanRow,
  Col as VanCol,
} from 'vant'
import { getApiV1CommunityList } from '@/api/sdk.gen'
import { mapApiPost, type ForumPost } from '@/stores/forum-store'
import { ForumUserImg, renderPostSummary, renderPostTitle } from '@/components/forum-post-parts'

// 对应 49208 /corpusdetaillist?type=3&userId=&title=&lotteryType= 作者历史帖子
// 页面根 class .corpusdetaillist-msg，列表卡片走全局 .forum-list 样式
export default defineComponent({
  name: 'ForumUserPostsPage',
  setup() {
    const route = useRoute()
    const router = useRouter()
  const goBack = useSmartBack()

    const userId = computed(() => Number(route.query.userId) || 0)
    const title = computed(() => String(route.query.title || '历史帖子'))
    const lotteryType = computed<1 | 2 | undefined>(() => {
      const v = Number(route.query.lotteryType)
      return v === 1 || v === 2 ? v : undefined
    })

    const list = ref<ForumPost[]>([])
    const page = ref(0)
    const loading = ref(false)
    const finished = ref(false)
    const refreshing = ref(false)

    async function fetchList() {
      if (!userId.value) {
        finished.value = true
        return
      }
      page.value += 1
      try {
        const res = await getApiV1CommunityList({
          query: {
            page: page.value,
            size: 20,
            target_id: userId.value,
            lottery_type: lotteryType.value,
          },
        })
        const items = (res.data?.data?.list ?? []).map(mapApiPost)
        list.value = [...list.value, ...items]
        if (items.length < 20) finished.value = true
      } finally {
        loading.value = false
      }
    }

    async function onRefresh() {
      list.value = []
      page.value = 0
      finished.value = false
      await fetchList()
      refreshing.value = false
    }

    onMounted(() => {
      fetchList()
    })

    function go(p: ForumPost) {
      router.push(`/forum/detail/${p.postId}`)
    }

    return () => (
      <div class="corpusdetaillist-msg">
        <VanSticky>
          <VanNavBar title={title.value} onClickLeft={() => goBack()}>
            {{
              left: () => <VanIcon name="arrow-left" color="#333" size="16" />,
            }}
          </VanNavBar>
        </VanSticky>

        <VanPullRefresh
          modelValue={refreshing.value}
          onUpdate:modelValue={(v: boolean) => (refreshing.value = v)}
          onRefresh={onRefresh}
        >
          <VanList
            class="forum-bd"
            loading={loading.value}
            onUpdate:loading={(v: boolean) => (loading.value = v)}
            finished={finished.value}
            finishedText="没有更多了"
            immediateCheck={false}
            onLoad={fetchList}
          >
            <ul class="forum-list">
              {list.value.map((post) => (
                <li key={post.postId}>
                  <div class="user-info-box">
                    <ForumUserImg post={post} />
                  </div>

                  <VanRow class="stitles" onClick={() => go(post)}>
                    <VanCol class="slabel">{post.periodStr}</VanCol>
                    <VanCol span={18}>
                      <div class="van19 van-ellipsis">
                        {renderPostTitle(post)}
                      </div>
                    </VanCol>
                  </VanRow>

                  {renderPostSummary(post)}

                  <VanRow class="tool-ft">
                    <VanCol span={8}>
                      <VanIcon name="good-job-o" size="15" />
                      <span class="num">{post.likeCount}</span>
                    </VanCol>
                    <VanCol span={8}>
                      <VanIcon name="eye-o" size="16" />
                      <span class="num">{post.clickCount}</span>
                    </VanCol>
                    <VanCol span={8}>
                      <VanIcon name="chat-o" size="15" />
                      <span class="num">{post.commentCount}</span>
                    </VanCol>
                  </VanRow>
                </li>
              ))}
            </ul>
          </VanList>
        </VanPullRefresh>
      </div>
    )
  },
})
